import axios from 'axios';
import * as URLS from '@/config/urls';
import * as CONFIG from "@/config/config";
import store from "@/store";

const url = 'https://junkit.vonigo.com/api/v1/data/'

const urlApi = 'https://junkit.vonigo.com/api/v1/'

export const availableTime = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = `${URLS.API_URL}${URLS.TIME_AVAILABLE}`;
		const requestData = {
			securityToken: data.securityToken,
			method: 0,
			serviceTypeID: data.serviceTypeID,
			zipCode: data.zip,
			duration: 60,
			dateStart: data.dateStartMounth,
			dateEnd: data.dateEndMounth,
			pageSize: 100,
			pageNo: 1,
		};
		axios
			.post(`${queryUrl}`, requestData, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}

export const lockTime = function (data: any) {

	return new Promise<any>((resolve, reject) => {
		const queryUrl = `${URLS.API_URL}${URLS.TIME_AVAILABLE}`;
		const requestData = {
			securityToken: data.securityToken,
			method: 2,
			dayID: data.dayID,
			routeID: data.routeID,
			zip: data.zip,
			serviceTypeID: 11,
			duration: 60,
			startTime: data.startTime
		};
		axios
			.post(`${queryUrl}`, requestData, {
				headers: {
					'Content-Type': 'application/json',
				},
			})
			.then(res => {
				resolve(res);
			})
			.catch(err => {
				reject(err);
			});
	});
}
